export type NotificationType = 'success' | 'warning' | 'error' | 'info' | '404';

export interface NotificationConfig {
  message?: string;
  imageUrl?: string;
  autoClose?: number;
}

export const NOTIFICATION_CONFIGS: {
  [key in NotificationType]: NotificationConfig;
} = {
  success: {
    message: '¡Operación exitosa!',
    imageUrl: '',
  },
  warning: {
    message: '¡Atención!',
    imageUrl: '',
  },
  error: {
    message: '¡Ha ocurrido un error!',
    imageUrl: '',
  },
  info: {
    message: 'Información importante',
    imageUrl: '',
  },
  404: {
    message: 'Recurso no encontrado',
    imageUrl: '',
  },
};
